@import '../styles/optical';

.clickableIcon {
  cursor: pointer;
}

.darkSwitch {
  [class~='ant-switch-inner-unchecked'],
  [class~='ant-switch-inner-checked'] {
    height: 22px;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
  }
}

.tabsWithShadow {
  :global {
    div.ant-tabs-nav {
      box-shadow: 0px 10px 20px -10px #00000029;

      @media (min-width: 801px) {
        margin-left: -50px;
        margin-right: -50px;
        padding-left: 50px;
        padding-right: 50px;
      }

      div.ant-tabs-nav-list.ant-tabs-nav-list.ant-tabs-nav-list.ant-tabs-nav-list {
        div.ant-tabs-tab:not(.ant-tabs-tab-active) {
          color: #7f88a1;
        }
      }
    }
  }
}

.darkTabs {
  :global {
    .ant-tabs-nav {
      margin-bottom: 0;
      .ant-tabs-nav-list {
        .ant-tabs-tab {
          padding-bottom: 13.5px;
          padding-top: 2px;
          .ant-tabs-tab-btn {
            font-size: 16px;
            line-height: 16px;
          }
        }
      }
    }
  }
}

.defaultModal {
  width: 674px;
  max-width: 95vw;

  @media (max-width: 281px) {
    max-width: 99vw;
    margin: 0 5px;
  }

  [class~='ant-modal-container'] {
    padding: 35px 50px;

    @media (max-width: 450px) {
      padding: 5vh 8vw;
    }
  }
  [class~='ant-modal-title'] {
    width: 95%;
  }
  [class~='ant-modal-close'] {
    top: 45px;
    right: 50px;
    font-weight: 900;

    @media (max-width: 450px) {
      top: 5vh;
      right: 8vw;
    }
  }
  [class~='ant-modal-footer'] {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    button {
      padding-left: 16px;
      padding-right: 16px;
    }

    @media (min-width: 400px) {
      button {
        padding-left: 32px;
        padding-right: 32px;
      }
    }
  }
}

.flexFooterModal {
  :global {
    .ant-modal-footer,
    .ant-modal-confirm-btns {
      @media (max-width: 800px) {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column-reverse !important;
        justify-content: center;
        row-gap: 10px;
        button {
          width: 100%;
          flex-grow: 1;
          margin: 0 !important;
        }
        .ant-btn {
          width: 100% !important;
          margin: 0 !important;
        }
      }
    }
  }
}

.defaultModalRoot {
  font-size: unset;

  :global {
    .ant-modal-centered {
      .ant-modal-container {
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }
}

@mixin common-button($h) {
  font-family: OrkneyMedium;
  font-size: 16px;
  padding-left: 2em;
  padding-right: 2em;
  height: $h;
}

.commonButton.commonButton.commonButton.commonButton.commonButton.commonButton {
  @include common-button(40px);
}
.commonButtonH35.commonButtonH35.commonButtonH35.commonButtonH35.commonButtonH35.commonButtonH35 {
  @include common-button(35px);
}

.commonButtonContainer {
  display: flex;
  flex-wrap: nowrap;
  column-gap: 16px;
  row-gap: 10px;
  justify-content: flex-end;

  :global {
    flex-wrap: wrap;

    button {
      @media (max-width: 800px) {
        flex-grow: 1;

        width: 100%;
      }
    }
  }
}

// Cabecera de las listas de contrataciones, la de la empresa y la del candidato. Vive aqui y no en
// cada `index.module.scss` porque las dos la usan igual, y duplicada el siguiente retoque del
// separador o del espaciado caeria en una sola.
.listHeaderCell {
  // Todo va dentro de la media query, y el `display` sobre todo. Por debajo de `md` la fila se
  // apila y la cabecera se pide oculta con `xs={0}`, pero antd escribe eso como
  // `:where(.css-...).ant-col-xs-0 { display: none }`, que pesa (0,1,0) igual que esta clase: con
  // un `display: flex` suelto aqui fuera gana el nuestro por ir la hoja despues, y la cabecera
  // seguia viendose en el movil. Medido a 390px, no supuesto.
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    min-height: 24px;

    // Orkney deja la banda de mayusculas por encima del centro optico. NO se usa `optical-box`
    // aqui: ese mixin dobla el desplazamiento porque cuenta con una caja de altura fija que
    // absorbe la mitad del padding, y esta no tiene holgura (medido: 25,08px de caja para una
    // linea de 22px), asi que el doble se le iba entero al texto.
    padding-top: $optical-nudge;

    &:not(:last-child) {
      // El mismo color que tomaba del tema el `Divider` que habia aqui, con su valor por defecto
      // de respaldo, que es como lo hace el resto de la hoja.
      border-right: 1px solid var(--ant-color-split, #0000000f);
    }
  }
}

// El hueco a la derecha del rotulo cuelga de aqui y no del `Col`, porque ese `Col` hospeda ademas
// la sub-rejilla 6/18 que replica el avatar de la celda: con el padding puesto en el `Col`, el 6/18
// se calcula sobre una caja 12px mas estrecha y el rotulo cae 3px a la izquierda del dato. Medido.
.listHeaderLabel {
  // Sin `width: 100%`: con el rotulo como item flex a lo ancho, el `flex-end` de `.listCellEnd` no
  // tiene nada que repartir y «Accion» se quedaba a la izquierda de su columna. Encogido al
  // contenido, el `padding-right` hace el mismo hueco y el `flex-end` vuelve a empujarlo.
  padding-right: 12px;
}

// La `Tag` de antd es `white-space: nowrap` y `.ant-col-N` fija un `max-width`, asi que la pastilla
// ni envuelve ni ensancha su columna: se sale por la derecha y tapa el boton de acciones. Medido,
// se desbordaba 64-91px en movil y 28-40px a 768px. Aqui se le deja envolver.
.listCellTag {
  :global(.ant-tag) {
    white-space: normal;
    height: auto;
  }
}

// La `Tag` del estado mete su propio `padding-inline`, asi que su cabecera lo iguala o se desplaza.
.listHeaderCellTag {
  padding-left: 8px;
}

.listCellEnd {
  justify-content: flex-end;
  padding-right: 0;

  // La ultima columna no lleva separador, asi que tampoco el hueco que lo separaba del rotulo.
  .listHeaderLabel {
    padding-right: 0;
  }
}
